module.exports = __webpack_public_path__ + "static/Tax_Banner_63_Desktop.d069e227.png";